import './styles.css';
import Flashcard from '../../components/Flashcard';
import {useLocation} from "react-router";


const CardScreen = () => {
    // const cards = [
    //   { question: 'Buga?', answer: 'Buga!' },
    //   { question: 'Who wrote this?', answer: 'Me!' },
    //   { question: 'Who are you?', answer: '¯\_(ツ)_/¯ no one cares' },
    //   // Add more cards here
    // ];

    let { state } = useLocation();
    console.log('z', state);
    console.log('q', Object.entries(state.cards));

    const cards = Object.entries(state.cards).map((x) => ({
        question: x[0],
        answer: x[1]
    }))

    console.log(cards);
  
    return (
      <div>
        <h1 className='head'>Review your Flashcards!</h1>
        <div className='flashcard'>
            <Flashcard cards={cards} />
        </div>
      </div>
    );
  };


export default CardScreen;